// Platforms
export const PLATFORMS = [
  'Bigo',
  'Facebook',
  'Google',
  'Newsbreak',
  'Reddit',
  'Rumble',
  'Snapchat',
  'Tiktok',
] as const;

export type Platform = typeof PLATFORMS[number];
